<div *ngIf="params.data && !params.data.editable">
    <span>{{ formattedDate }}</span>
  </div>
  <div *ngIf="params.data && params.data.editable && (currentField === 'expectedcompletion')">
    <input type="date" [(ngModel)]="displayDateValue" (ngModelChange)="onDateValueInput($event)" [min]="dateToday" onkeydown="return false;" (click)="openDatePicker($event)">
  </div>
  <div *ngIf="params.data && params.data.editable && (currentField === 'legitimizationdate')">
    <input type="date" [(ngModel)]="displayDateValue" (ngModelChange)="onDateValueInput($event)" [min]="jan2004" onkeydown="return false;" (click)="openDatePicker($event)">
  </div>
  